function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Notice from './notice.js';
var __vue_script__ = {
  name: 'Notification',
  components: {
    Notice: Notice
  },
  props: {
    prefixCls: {
      type: String,
      default: 'v-notification'
    },
    notificationClass: {
      type: [String, Array, Object],
      default: ''
    },
    notificationStyle: {
      type: Object,
      default: null
    },
    transitionName: {
      type: String,
      default: ''
    },
    animation: {
      type: String,
      default: 'fade'
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    classes: function classes() {
      var prefixCls = this.prefixCls;
      return _defineProperty({}, prefixCls, true);
    },
    groupTransition: function groupTransition() {
      var prefixCls = this.prefixCls,
          transitionName = this.transitionName,
          animation = this.animation;
      var name = transitionName;

      if (!name && animation) {
        name = "".concat(prefixCls, "-").concat(animation);
      }

      return name;
    }
  },
  methods: {
    onClose: function onClose(item) {
      var value = this.value;
      this.$emit('input', value.filter(function (v) {
        return v !== item;
      }));

      if (typeof item.onClose === 'function') {
        item.onClose();
      }
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: [_vm.classes, _vm.notificationClass],
    style: _vm.notificationStyle
  }, [_c('transition-group', {
    attrs: {
      "tag": "div",
      "appear": "",
      "name": _vm.groupTransition
    }
  }, _vm._l(_vm.value, function (item) {
    return _c('notice', _vm._b({
      key: item.$$id,
      class: item.className,
      style: item.style,
      attrs: {
        "prefix-cls": _vm.prefixCls
      },
      on: {
        "close": function close() {
          return _vm.onClose(item);
        }
      }
    }, 'notice', item.props, false));
  }), 1)], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "notification.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);